
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { usePerformanceYear } from "@/contexts/PerformanceYearContext";

export const useDialogManagement = (
  currentUser: any,
  userPerformanceBand: any,
  setUserPerformanceBand: (band: any) => void
) => {
  const [showDisagreementDialog, setShowDisagreementDialog] = useState(false);
  const [showBandDisagreementDialog, setShowBandDisagreementDialog] = useState(false);
  const [showAcceptDialog, setShowAcceptDialog] = useState(false);
  const [showDisagreeDialog, setShowDisagreeDialog] = useState(false);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const { activeYear } = usePerformanceYear();

  const handleAccept = async () => {
    if (!currentUser) return;

    try {
      console.log('Accepting performance band for user:', currentUser.id);
      
      // Update via SECURITY DEFINER RPC — employees can only change status, no other columns.
      const { error: updateError } = await supabase.rpc('set_performance_band_status', {
        p_year: activeYear,
        p_status: 'Final Band Accepted',
      });

      if (updateError) {
        console.error('Error updating performance band status:', updateError);
        setDialogMessage(`Failed to accept performance band: ${updateError.message}`);
        setShowErrorDialog(true);
        return;
      }

      console.log('Performance band status updated successfully');

      // Update local state
      setUserPerformanceBand({
        ...userPerformanceBand,
        status: 'Final Band Accepted'
      });

      setDialogMessage("Final band acceptance saved");
      setShowAcceptDialog(true);

    } catch (error) {
      console.error('Error accepting performance band:', error);
      setDialogMessage("An unexpected error occurred. Please try again.");
      setShowErrorDialog(true);
    }
  };

  const handleDisagree = () => {
    // Simply open the band disagreement dialog
    setShowBandDisagreementDialog(true);
  };

  const handleDisagreementSuccess = () => {
    setShowDisagreementDialog(true);
    setShowBandDisagreementDialog(false);
    
    // Update local state to reflect the disagreement
    setUserPerformanceBand({
      ...userPerformanceBand,
      status: 'Band disagreement submitted'
    });
  };

  const handleDisagreementError = (error: string) => {
    console.error('Disagreement submission error:', error);
  };

  return {
    showDisagreementDialog,
    setShowDisagreementDialog,
    showBandDisagreementDialog,
    setShowBandDisagreementDialog,
    showAcceptDialog,
    setShowAcceptDialog,
    showDisagreeDialog,
    setShowDisagreeDialog,
    showErrorDialog,
    setShowErrorDialog,
    dialogMessage,
    handleAccept,
    handleDisagree,
    handleDisagreementSuccess,
    handleDisagreementError
  };
};
